import { useSyncExternalStore } from "react";
import {
  getAimgViewerContext,
  subscribeAimgViewerContext,
} from "@/shared/api/client";

/** raw tokenを公開せず、token発行・refresh・clearごとに変わるQuery cache世代。 */
export function useAimgViewerContext(): number {
  return useSyncExternalStore(
    subscribeAimgViewerContext,
    getAimgViewerContext,
    getAimgViewerContext,
  );
}
